export const TO_IGNORE_ERRORS: (string | RegExp)[] = [
  /ResizeObserver loop/,
  'Non-Error promise rejection',
  /pinterest/,
  /runtime.sendMessage/,
  /\(evaluating 'window\./,
  /__firefox__/
]
